
import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { catchError, EMPTY, filter, Observable, take } from 'rxjs';
import { RequestStore } from '../../common-data/stores/request.store';
import { VendorCatalogRequest } from 'src/app/shared/models/request.model';


@Injectable({
  providedIn: 'root',
})
export class AdminRequestResolver implements Resolve<VendorCatalogRequest> {
    constructor(private store: RequestStore, private router: Router) {}

    resolve(
        route: ActivatedRouteSnapshot,
      ): Observable<VendorCatalogRequest> {
        const idParam = route.paramMap.get('id');
        if (!idParam) {
          // ohne ID zurück zur Liste
          this.router.navigate(['/admin-requests']);
          return EMPTY;
        }
        const id = Number(idParam);
        return this.store.loadRequestsById(id).pipe(
          catchError(err => {
            // bei Fehler z.B. auf Notfound umleiten
            this.router.navigate(['/notfound']);
            return EMPTY;
          })
        );
      }
    }
  
  
